import React from 'react'
import { Stack } from '@mantine/core'
import LabeledContainer from '../../../components/LabeledContainer'
import ReportWrapper from '../ReportWrapper'
import PageEmpty from '../../../components/PageEmpty'
import CompanySummary from './CompanySummary'
import CompanyList from './CompanyList'
import { CdDataRelationCompanyData, CompanyItem } from './types'

interface RongdataRelationCompanyInformationProps {
  data: any
  title: string
}

const RongdataRelationCompanyInformation: React.FC<RongdataRelationCompanyInformationProps> = ({ data, title }) => {
  const jsonData: CdDataRelationCompanyData = JSON.parse(data.cddata_relation_companies ?? '{}')
  const companies: CompanyItem[] = jsonData?.queryResult?.items || []

  return (
    <ReportWrapper>
      <LabeledContainer title={title} />
      <Stack>
        {companies.length === 0 ? (
          <PageEmpty image={'/good.png'} title={'暂无数据'} size={80} />
        ) : (
          <>
            <CompanySummary companies={companies} />
            <CompanyList companies={companies} />
          </>
        )}
      </Stack>
    </ReportWrapper>
  )
}

export default RongdataRelationCompanyInformation
